import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { BACKEND_URL } from '../../../../util/api'
import currentUserHasAccess from '../../../../util/widget-helper'
import { PRODUCTION_CASE_CARD_WIDGET } from '../../../process/ui-definition/process-ui'

const iframeStyle = {
    width: '100%',
    height: '700px',
}

const ProductionCaseCardWidget = ({ salesOrder }) => {
    if (!currentUserHasAccess(PRODUCTION_CASE_CARD_WIDGET)) {
        return null
    }

    if (!salesOrder) {
        return null
    }

    const viewLink = BACKEND_URL + '/api/production/render-production-case-card?salesOrderId=' + salesOrder.id

    return (
        <ContentBox title={'Production Case Card' + salesOrder.referenceNumber}>
            <Row>
                <Column size={12}>
                    <iframe src={viewLink} title="Production Case Card" style={iframeStyle}/>
                </Column>
            </Row>
        </ContentBox>
    )
}


ProductionCaseCardWidget.propTypes = {
    salesOrder: PropTypes.object,
}

export default ProductionCaseCardWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/ProductionCaseCardWidget.js